import { __rest, __assign } from '../../_virtual/_tslib.js';
import React from 'react';
import SVGWrapper from '../../SVGWrapper/index.js';
var children = {
  check: function check(color) {
    return React.createElement("path", {
      xmlns: "http://www.w3.org/2000/svg",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 8.47363C20 8.20707 19.8968 7.94052 19.711 7.7486L18.3071 6.29854C18.1213 6.10662 17.8632 6 17.6052 6C17.3471 6 17.089 6.10662 16.9032 6.29854L10.1316 13.3036L7.09677 10.1582C6.91097 9.96633 6.6529 9.85971 6.39484 9.85971C6.13677 9.85971 5.87871 9.96633 5.6929 10.1582L4.28903 11.6083C4.10323 11.8002 4 12.0668 4 12.3333C4 12.5999 4.10323 12.8664 4.28903 13.0584L9.42968 18.3681C9.61548 18.56 9.87355 18.6667 10.1316 18.6667C10.3897 18.6667 10.6477 18.56 10.8335 18.3681L19.711 9.19865C19.8968 9.00673 20 8.74018 20 8.47363Z",
      fill: color
    });
  },
  info: function info(color) {
    return React.createElement("path", {
      xmlns: "http://www.w3.org/2000/svg",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.2 16H12.8V11.2H11.2V16ZM12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4ZM12.0001 18.4C8.47207 18.4 5.60007 15.528 5.60007 12C5.60007 8.47198 8.47207 5.59998 12.0001 5.59998C15.5281 5.59998 18.4001 8.47198 18.4001 12C18.4001 15.528 15.5281 18.4 12.0001 18.4ZM11.2 9.6H12.8V8H11.2V9.6Z",
      fill: color
    });
  },
  danger: function danger(color) {
    return React.createElement(React.Fragment, null, React.createElement("mask", {
      xmlns: "http://www.w3.org/2000/svg",
      id: "mask0",
      style: {
        maskType: 'alpha'
      },
      maskUnits: "userSpaceOnUse",
      x: "3",
      y: "4",
      width: "18",
      height: "16"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.83825 17.5098C3.46329 18.1764 3.945 19.0001 4.70983 19.0001L19.2901 19.0001C20.055 19.0001 20.5367 18.1764 20.1617 17.5098L12.8716 4.54953C12.4893 3.86988 11.5107 3.86988 11.1284 4.54953L3.83825 17.5098ZM13 17.0001H11V15.0001H13V17.0001ZM11 13.0001H13V9.00006L11 9.00006L11 13.0001Z",
      fill: "white"
    })), React.createElement("g", {
      xmlns: "http://www.w3.org/2000/svg",
      mask: "url(#mask0)"
    }, React.createElement("rect", {
      x: "21",
      y: "19.0001",
      width: "18",
      height: "16",
      transform: "rotate(-180 21 19.0001)",
      fill: color
    })));
  },
  trash: function trash(color) {
    return React.createElement("path", {
      xmlns: "http://www.w3.org/2000/svg",
      d: "M9.375 4V4.88889H5V6.66667H5.875V18.2222C5.875 18.6937 6.05937 19.1459 6.38756 19.4793C6.71575 19.8127 7.16087 20 7.625 20H16.375C16.8391 20 17.2842 19.8127 17.6124 19.4793C17.9406 19.1459 18.125 18.6937 18.125 18.2222V6.66667H19V4.88889H14.625V4H9.375ZM9.375 9.31944C9.375 8.8362 9.76675 8.44444 10.25 8.44444C10.7332 8.44444 11.125 8.8362 11.125 9.31944V15.5694C11.125 16.0527 10.7332 16.4444 10.25 16.4444C9.76675 16.4444 9.375 16.0527 9.375 15.5694V9.31944ZM12.875 9.31944C12.875 8.8362 13.2668 8.44444 13.75 8.44444C14.2332 8.44444 14.625 8.8362 14.625 9.31944V15.5694C14.625 16.0527 14.2332 16.4444 13.75 16.4444C13.2668 16.4444 12.875 16.0527 12.875 15.5694V9.31944Z",
      fill: color
    });
  }
};
var iconSize = {
  large: 40,
  medium: 32,
  small: 24,
  'x-small': 18
};
var defaultColor = {
  check: '#52CF29',
  info: '#548FCC',
  danger: '#FF5848',
  trash: '#FF5848'
};

function State(_a) {
  var styleType = _a.styleType,
      size = _a.size,
      color = _a.color,
      onClick = _a.onClick,
      style = _a.style,
      props = __rest(_a, ["styleType", "size", "color", "onClick", "style"]);

  return React.createElement(SVGWrapper, __assign({
    width: iconSize[size],
    height: iconSize[size],
    ratio: {
      x: iconSize[size] / iconSize.small,
      y: iconSize[size] / iconSize.small
    },
    onClick: onClick,
    style: style
  }, props), styleType && children[styleType](color || defaultColor[styleType]));
}

export { State as default };